import {Dialog} from '@primer/react'
import {useMemo} from 'react'

import {DialogType} from '../state-providers/modals/add-field-modal-state-provider'
import {useAddIssueFieldsDialog, type UseAddIssueFieldsDialogProps} from './use-add-issue-fields-dialog'
import {useAddProjectFieldDialog, type UseAddProjectFieldDialogProps} from './use-add-project-field-dialog'

type AddFieldsDialogProps = Omit<UseAddProjectFieldDialogProps & UseAddIssueFieldsDialogProps, 'isOpen'> & {
  dialogType: DialogType
}

export function AddFieldsDialog({
  dialogType,
  setOpen,
  onSave,
  issueFields,
  openAddColumnDialog,
  issueFieldsLoading,
  onSelectFieldWithCollision,
  selectedFieldIds,
  setSelectedFieldIds,
  limitedTypes,
  onBack,
}: AddFieldsDialogProps) {
  const issueFieldsDialogProps = useAddIssueFieldsDialog({
    isOpen: dialogType === DialogType.IssueFields,
    setOpen,
    onSave,
    issueFields,
    openAddColumnDialog,
    issueFieldsLoading,
    onSelectFieldWithCollision,
    selectedFieldIds,
    setSelectedFieldIds,
  })
  const projectFieldDialogProps = useAddProjectFieldDialog({
    isOpen: dialogType === DialogType.AddColumn,
    setOpen,
    onSave,
    limitedTypes,
    onBack,
  })

  const dialogProps = useMemo(
    () => (dialogType === DialogType.AddColumn ? projectFieldDialogProps : issueFieldsDialogProps),
    [dialogType, issueFieldsDialogProps, projectFieldDialogProps],
  )

  return <Dialog height="auto" width="large" {...dialogProps} />
}

try{ AddFieldsDialog.displayName ||= 'AddFieldsDialog' } catch {}